import React from 'react'
import OptionSelector from '../shared/OptionSelector'
import WindowDiagram from '../diagrams/WindowDiagram'

const BlindsTab = ({
  formData,
  onChange,
  availableOptions,
  windowProduct
}) => {
  const useDiagram = windowProduct.name === '2-Lite Sliding Glass Door'

  return (
    <div className="space-y-6 py-4">
      {useDiagram ? (
        <WindowDiagram
          windowTypeName={windowProduct.name}
          selectedValue={formData.internal_blind_id}
          availableOptions={availableOptions.internal_blinds}
          onChange={(value) => onChange('internal_blind_id', value)}
          mode="blinds"
        />
      ) : (
        <OptionSelector
          label="Internal Blinds"
          name="internal_blind_id"
          options={availableOptions.internal_blinds}
          value={formData.internal_blind_id}
          onChange={(value) => onChange('internal_blind_id', value)}
        />
      )}
    </div>
  )
}

export default BlindsTab
